export function formatBytes(bytes) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
    if ( bytes === 0 ) return 'n/a'

    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)

    if ( i === 0 ) return `${bytes} ${sizes[i]})`

    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
}


export function throttle(fn, wait) {
    let time = Date.now()
    return function() {
        if ( (time + wait - Date.now()) < 0 ) {
            fn()
            time = Date.now()
        }
    }
}

export function isSafari() {
    return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
}

export function isIos() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}


export function right(element) {
    return window.innerWidth - (element.getBoundingClientRect().left + element.offsetWidth)
}

export function bgImage(image) {
    return 'background-image: url("' + image + '")'
}

export function toggleVisibility(el) {

    if ( el.style.display === 'block' )
        el.style.display = 'none';
    else
        el.style.display = 'block';
}

export function setElHeight(el) {
    let maxHeight = 0

    el.forEach( item => {
        if ( item.clientHeight > maxHeight )
            maxHeight = item.clientHeight
    })

    el.forEach( item => {
        item.style.height = maxHeight + 'px'
    })
}

export function scrollToTop(duration) {

    // cancel if already on top
    if ( document.scrollingElement.scrollTop === 0 ) return;

    const totalScrollDistance = document.scrollingElement.scrollTop;

    let scrollY = totalScrollDistance, oldTimestamp = null;

    function step (newTimestamp) {

        if ( oldTimestamp !== null ) {
            // if duration is 0 scrollY will be -Infinity
            scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;

            if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;

            document.scrollingElement.scrollTop = scrollY;
        }

        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
}

export function siblings( elem  ) {
    return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
        return sibling !== elem;
    })
}

export function setCheckbox(selector, data) {
    Array.from(document.querySelectorAll(selector)).forEach( (input) => {
        if ( data.includes(input.value) ) {
            input.checked = true
        }
    })
}

export function setSelectOption(selector, value) {
    Array.from(document.querySelector(selector).options).forEach( (option) => {
        if ( option.value === value ) {
            option.setAttribute('selected', true)
        }
    })
}
export function showMore(items) {
   items.forEach(item => {
        item.classList.remove('d-none')
    })
}

export function getFromCategoriesBy(index, categories) {

    // if index is last
    // if ( index === 'last' ) {
    //     return categories[categories.length - 1].name
    // }

    // if index is first
    // if ( index === 'first' ) {
    //     return categories[0].name
    // }

    // if index is number
    if ( typeof index === 'number' ) {
        let position = categories.length - index

        if ( position < 0 ) {
            return ''
        } else {
            // category exists with this position && category id is not 1
            if ( categories[position] && categories[position].pivot.category_id !== 1 ) {
                return categories[position].name
            } else {
                return ''
            }
        }
    }

    return ''
}

// write function from helpers.php getCategoryByPosition to javascript
export function getCategoryByPosition(position, categories) {
    let category = categories[categories.length - position]

    if ( category && category.pivot.category_id !== 1 ) {
        return category.name
    } else {
        return ''
    }
}

export function isJson(str) {

    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }

    return true
}

export function log(value) {
    console.log(value)
}

